<template>
	<div class="start-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.business_start_page_v2.sec_01.title.one') }}<br />
					{{ $t('new_ui.business_start_page_v2.sec_01.title.two') }}
					<strong>
						{{ $t('new_ui.business_start_page_v2.sec_01.title.three') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.business_start_page_v2.sec_01.desc.one') }}<br />
					{{ $t('new_ui.business_start_page_v2.sec_01.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.business_start_page_v2.sec_01.btn.one') }}
					</a>
					<a href="/service/cs/cs" class="btn-type-02">
						{{ $t('new_ui.business_start_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-14">
			<div class="container-box">
				<a href="/service/cs/cs" class="btn-type-03">
					{{ $t('new_ui.business_start_page_v2.sec_14.btn') }}
					<img :src="img.iconArrowRightCircle" alt="" />
				</a>
			</div>
		</section>
		<section class="sec-04">
			<div class="container-box">
				<h3 class="title">
					{{ $t('new_ui.business_start_page_v2.sec_04.title.one') }}
				</h3>
				<p class="desc">
					{{ $t('new_ui.business_start_page_v2.sec_04.desc.one') }}
				</p>
				<div class="card-box">
					<div class="card-content card-content-01">
						<div class="txt">
							<h5>
								{{
									$t('new_ui.business_start_page_v2.sec_04.cards.one.title.one')
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.business_start_page_v2.sec_04.cards.one.description.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.business_start_page_v2.sec_04.cards.one.description.two',
									)
								}}
							</p>
							<a href="/auth/register" class="btn-type-02">
								{{ $t('new_ui.business_start_page_v2.sec_04.cards.one.btn') }}
							</a>
						</div>
						<img :src="img.iconStart01" alt="" />
					</div>
					<div class="card-content card-content-02">
						<div class="txt">
							<h5>
								{{
									$t('new_ui.business_start_page_v2.sec_04.cards.two.title.one')
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.business_start_page_v2.sec_04.cards.two.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.business_start_page_v2.sec_04.cards.two.description.two',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.business_start_page_v2.sec_04.cards.two.description.three',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.business_start_page_v2.sec_04.cards.two.description.four',
									)
								}}
							</p>
						</div>
						<img :src="img.iconStart02" alt="" />
					</div>
				</div>
				<div class="btn-box">
					<a href="mailto:support@jpworldpay.com" class="btn-type-01">
						<img :src="img.iconMailWhite" alt="" />
						{{ $t('new_ui.business_start_page_v2.sec_04.btn') }}
					</a>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import iconStart01 from '@/assets/images/v2/icon/icon-start-01.svg';
import iconStart02 from '@/assets/images/v2/icon/icon-start-02.svg';
import iconMailWhite from '@/assets/images/v2/icon/icon-mail-white.svg';
import iconArrowRightCircle from '@/assets/images/v2/icon/icon-arrow-right-circle.svg';

export default {
	data: () => {
		return {
			img: {
				iconStart01,
				iconStart02,
				iconMailWhite,
				iconArrowRightCircle,
			},
		};
	},
};
</script>
